export default "__VITE_ASSET__Bsk__X5U__"